import { render, staticRenderFns } from "./WorkflowsFeatures.vue?vue&type=template&id=51cbf19d"
import script from "./WorkflowsFeatures.vue?vue&type=script&lang=js"
export * from "./WorkflowsFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports